import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import IsoCertification from './IsoCertification';
import signature from '../Images/signature.png'

// --- STYLED COMPONENTS ---

const Container = styled.div`
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 20px;
  color: #333333;
  line-height: 1.6;
`;

const HeaderContainer = styled.header`
  // margin-bottom: 40px;
  border-bottom: 2px solid #e2e8f0;
  // padding-bottom: 15px;
`;

const MainTitle = styled.h1`
  font-size: 1.8rem;
  font-weight: 700;
  color: #439E6D; /* Deep corporate navy blue */
  text-transform: uppercase;
  letter-spacing: 0.5px;
  // margin: 0 0 5px 0;
`;

const SubTitle = styled.h2`
  font-size: 1.3rem;
  font-weight: 600;
  color: #439E6D;
  text-transform: uppercase;
  margin: 0;
`;

const IntroText = styled.p`
  font-size: 1.1rem;
  text-align: justify;
  // margin-bottom: 30px;

  &::first-letter {
    font-size: 2.2rem;
    font-weight: bold;
    color: #0c2340;
    float: left;
    line-height: 1;
    padding-right: 4px;
  }
`;

const PolicyDeclaration = styled.h3`
  font-size: 1.4rem;
  font-weight: 700;
  color: #439E6D;
  margin-top: 10px;
  // margin-bottom: 25px;
`;

const List = styled.ol`
  list-style-type: none;
  counter-reset: item-counter;
  padding-left: 0;
  // margin-bottom: 35px;
`;

const ListItem = styled.li`
  counter-increment: item-counter;
  // margin-bottom: 14px;
  font-size: 1.1rem;
  display: flex;
  align-items: flex-start;
  text-align: justify;

  &::before {
    content: counter(item-counter) ". ";
    font-weight: bold;
    color: #0c2340;
    margin-right: 10px;
    flex-shrink: 0;
  }
`;

const FooterText = styled.p`
  font-size: 0.95rem;
  text-align: justify;
  margin-top: 10px;
  // margin-bottom: 40px;
  font-weight: 500;
`;

const SignatureContainer = styled.div`
  // margin-top: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 100px;

  img {
    max-width: 200px;
    height: auto;
    object-fit: contain;
  }
`;

// --- MAIN COMPONENT ---

const HsePolicy = () => {
  return (
    <Container>
      {/* Title Section */}
      <Fade triggerOnce direction="up" duration={800}>
        <HeaderContainer>
          <MainTitle>OUR HEALTH AND ENVIRONMENTAL POLICY</MainTitle>
          <SubTitle>PADEC GLOBAL SERVICES HSE</SubTitle>
        </HeaderContainer>
      </Fade>

      <IsoCertification/>

      {/* Intro Paragraph */}
      <Fade triggerOnce direction="up" duration={800} delay={100}>
        <IntroText>
          The long-term business success of PADEC GLOBAL SERVICES LTD depends on our ability to continually improve the quality of our services while protecting our employees and the environment. Emphasis must be placed on ensuring human health, operational safety, environmental protection, and community goodwill. This commitment is in the best interests of our clients, our employees and contractors, our stockholders, and the communities in which we operate. PADEC GLOBAL SERVICES LTD requires the active
        </IntroText>
      </Fade>

      <Fade triggerOnce direction="up" duration={800} delay={150}>
        <PolicyDeclaration>It is our policy to: -</PolicyDeclaration>
      </Fade>

      {/* First Policy List */}
      <List>
        <Fade triggerOnce cascade direction="up" duration={600} fraction={0.1} damping={0.1}>
          <ListItem>
            Ensure safe operations in all our services and provide safe facilities and equipment that are properly designed, constructed, maintained operated, and inspected.
          </ListItem>
          <ListItem>
            Perform all our activities in conformity with federal, state, and local government laws, and in conformity with local and international standards and PADEC GLOBAL SERVICES LTD policies.
          </ListItem>
          <ListItem>
            Set objectives that will continually support HSE management system improvement.
          </ListItem>
          <ListItem>
            It is the duty of all our personnel, at every level, to manage the risks inherent in our operations; this duty is a vital part of operational management.
          </ListItem>
          <ListItem>
            In carrying out our business activities, the hazards to which people, the environment and assets are exposed are methodically identified, the associated risks assessed, and the measures for reducing them are defined and implemented.
          </ListItem>
          <ListItem>
            Minimize impact on the environment through pollution prevention, reduction, and recycling of waste.
          </ListItem>
        </Fade>
      </List>

      {/* Second Policy List */}
      <List style={{ counterReset: 'item-counter' }}>
        <Fade triggerOnce cascade direction="up" duration={600} fraction={0.1} damping={0.1}>
          <ListItem>
            Monitor the health of all employees regularly to ensure they are not adversely affected by the workplace.
          </ListItem>
          <ListItem>
            Assist our contractors and suppliers to comply with our HSE standards.
          </ListItem>
          <ListItem>
            Provide adequate resources and training programs to ensure that our employees are aware of our HSE requirements and abide by them.
          </ListItem>
          <ListItem>
            Develop and implement adequate emergency response procedures and resources to mitigate the impact of incidents and/or accidental in our operations.
          </ListItem>
          <ListItem>
            Report and investigate all accidents, incidents, and non-conformances to improve our HSE management system.
          </ListItem>
          <ListItem>
            Reward those who contribute to HSE performance improvement.
          </ListItem>
          <ListItem>
            Perform internal audits and periodic reviews and inspections to identify underperformances and possible areas of improvement.
          </ListItem>
        </Fade>
      </List>

      {/* Closing Statement */}
      <Fade triggerOnce direction="up" duration={800}>
        <FooterText>
          These objectives are critical to our business success as it allows us to minimize all losses systematically and add value for all our stakeholders. With the continuous dedication of all personnel, we will achieve these objectives.
        </FooterText>
      </Fade>

      {/* Signature Image Slot */}
      <Fade triggerOnce direction="up" duration={800} delay={200}>
        <SignatureContainer>
          {/* Replace path below with your actual signature image asset path */}
          <img src={signature} alt="Authorized Signature" />
        </SignatureContainer>
      </Fade>
    </Container>
  );
};

export default HsePolicy;